import React from "react";
import Skeleton from "react-loading-skeleton";

const SkeletonLoaderBasic = () => {
    return (
        <div style={{ flex: 1 }}>
            <Skeleton width={252} height={252} />
        </div>
    );
};

export default SkeletonLoaderBasic;
